export function initCourseMapToggle() {
  let parentSemesters = $(".program__courseMap");

  parentSemesters.each(function () {
    let semester = $(this);
    let semesterToggle = semester.find(".js-courseSemester");
    let desktopSemesters = semester.find(".js-desktopSemesters");

    semesterToggle.off("click").on("click", function (event) {
      let _this = $(this);
      let _thisAction = _this.data("action");

      if ($(event.target).closest(".program__courseMap__semester__mobileCourses").length) {
        return;
      }

      if (_this.hasClass("-active")) {
        _this.removeClass("-active");
        desktopSemesters.removeClass("-active");
      } else {
        semesterToggle.removeClass("-active");
        desktopSemesters.removeClass("-active");

        _this.addClass("-active");
        desktopSemesters.filter(`[data-action="${_thisAction}"]`).addClass("-active");
      }
    });
  });
}